/**
 * Local development entry point.
 * In production, ModuleApp is loaded as a remote module by the xplatform shell.
 */
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ModuleApp from "@src/ModuleApp";

const basename = import.meta.env.VITE_ROUTER_BASENAME ?? "/dqm";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter basename={basename}>
    <ModuleApp />
  </BrowserRouter>
);
